import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_blank_career.svg'


const _withScopeId = n => (_pushScopeId("data-v-3bd6fa4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title" }, "次のステップ", -1))
const _hoisted_3 = { class: "home_layout" }
const _hoisted_4 = { class: "home_career_layout" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_career_title" }, "キャリアシートを完成させましょう", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_career_time" }, "（約5分）", -1))
const _hoisted_7 = { class: "home_career_indicator" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_career_text" }, "キャリアシートを完成させることで、面談のご予約が可能になります。", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home_career_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "home_career_button" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title" }, "応募までの流れ", -1))
const _hoisted_12 = { class: "home_layout" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"home_step\" data-v-3bd6fa4e><a class=\"home_step_item home_step_item_size_large\" href=\"#jump_step_1\" data-v-3bd6fa4e><span class=\"home_step_item_title home_step_item_size_large\" data-v-3bd6fa4e>STEP1</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>キャリアシートの入力</span></a><a class=\"home_step_item\" href=\"#jump_step_2\" data-v-3bd6fa4e><span class=\"home_step_item_title\" data-v-3bd6fa4e>STEP2</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>面談・相談</span></a><a class=\"home_step_item\" href=\"#jump_step_3\" data-v-3bd6fa4e><span class=\"home_step_item_title\" data-v-3bd6fa4e>STEP3</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>求人のご紹介</span></a><a class=\"home_step_item home_step_item_size_large\" href=\"#jump_step_4\" data-v-3bd6fa4e><span class=\"home_step_item_title\" data-v-3bd6fa4e>STEP4</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>応募・書類選考</span></a><a class=\"home_step_item\" href=\"#jump_step_5\" data-v-3bd6fa4e><span class=\"home_step_item_title\" data-v-3bd6fa4e>STEP5</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>面接</span></a><a class=\"home_step_item\" href=\"#jump_step_6\" data-v-3bd6fa4e><span class=\"home_step_item_title\" data-v-3bd6fa4e>STEP6</span><span class=\"home_step_item_text\" data-v-3bd6fa4e>内定・入社</span></a></div><div class=\"home_layout_title\" id=\"jump_step_1\" data-v-3bd6fa4e>STEP1 キャリアシートの入力</div><p class=\"home_layout_text\" data-v-3bd6fa4e>下記ボタンから、あなたの経歴や希望の職種・業種などを入力してください。</p>", 3)
const _hoisted_16 = { class: "home_layout_button" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"home_layout_title\" id=\"jump_step_2\" data-v-3bd6fa4e>STEP2 面談・相談</div><p class=\"home_layout_text_list\" data-v-3bd6fa4e> マーケティング・クリエイティブを中心とした業界や、幅広い職種に精通したプロのキャリアコンサルタントが、これまでのご経歴やご希望をじっくりお伺いします。転職に関する疑問やお悩みなどのご相談も承っております。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 履歴書や職務経歴書などの書類ではわからないあなたの強みやご意向を把握し、応募企業にご推薦することで、書類選考通過率の向上に努めています。ぜひ、あなたのことを率直に教えてください。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 面談・相談は、Webもしくは電話にて対応しています。土日や平日の夜も受け付けています。所要時間は60分～90分程度です。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e>サービスはすべて無料で秘密厳守です。</p><p class=\"home_layout_title_sencondary\" data-v-3bd6fa4e>面談・相談の流れ</p><p class=\"home_layout_tertiary\" data-v-3bd6fa4e>1. マスメディアンの転職支援サービスをご説明</p><p class=\"home_layout_text\" data-v-3bd6fa4e> キャリアコンサルタントが、マスメディアンの転職支援サービスや、転職までの流れについて詳しくご説明します。 </p><p class=\"home_layout_tertiary\" data-v-3bd6fa4e>2. ご経歴のヒヤリング</p><p class=\"home_layout_text\" data-v-3bd6fa4e> 履歴書や職務経歴書、ポートフォリオを見ながら、これまでの社会人経験を一緒に整理。あなたの強みを客観的に把握し、効果的な書類のつくり方もアドバイスします。 </p><p class=\"home_layout_tertiary\" data-v-3bd6fa4e>3. ご希望のヒヤリング</p><p class=\"home_layout_text\" data-v-3bd6fa4e>業界、職種、年収、待遇などのご希望をじっくり伺い、今後の方向性、キャリアプランを共有します。</p><p class=\"home_layout_tertiary\" data-v-3bd6fa4e>4. ご相談・アドバイス</p><p class=\"home_layout_text\" data-v-3bd6fa4e> ヒヤリングをもとに、一人ひとりにあったキャリアプランをご提案。目の前の転職の成功だけではなく、長いキャリアを見据えたアドバイスもいたします。時には、今のタイミングでの転職をおすすめしない場合も。 </p><p class=\"home_layout_tertiary\" data-v-3bd6fa4e>5. 求人のご紹介</p><p class=\"home_layout_text\" data-v-3bd6fa4e> キャリアプランをもとに、マーケティング・クリエイティブ職種など幅広い求人の中から、あなたにマッチした企業をご紹介します。 </p><p class=\"home_layout_text_annotation\" data-v-3bd6fa4e> 希望・経験・職種・勤務地によっては求人の取り扱いがない場合があります。予めご了承ください。 </p><p class=\"home_layout_title_sencondary\" data-v-3bd6fa4e>予約方法</p><p class=\"home_layout_text\" data-v-3bd6fa4e>完全予約制です。ご都合に合わせて簡単にマイページからご予約ください。</p><p class=\"home_layout_title_sencondary\" data-v-3bd6fa4e>ご用意いただく書類</p><p class=\"home_layout_text_document_list\" data-v-3bd6fa4e>履歴書（顔写真添付）</p><p class=\"home_layout_text_document_list\" data-v-3bd6fa4e>職務経歴書</p><p class=\"home_layout_text_document_list\" data-v-3bd6fa4e>作品集や企画書など（クリエイティブ、プランナー職をご希望の方）</p><div class=\"home_layout_link\" data-v-3bd6fa4e><a class=\"text_link\" href=\"https://www.massmedian.co.jp/service/flow/prepare.html\" target=\"_blank\" data-v-3bd6fa4e>ご用意いただく書類の詳細 ＞</a></div><div class=\"home_layout_title\" id=\"jump_step_3\" data-v-3bd6fa4e>STEP3 求人のご紹介</div><p class=\"home_layout_text\" data-v-3bd6fa4e> 通常の求人には載っていない情報（企業の風土や職場環境、社長・社員の人柄など）もお伝えしながら、ご希望やご経験にあった求人をご紹介。人事部だけでなく、経営者や現場との人脈を持つマスメディアンにしかない特命・非公開求人も多いです。最近では一般企業の宣伝、広報、マーケティング、デジタル部門の求人も増加傾向にあります。 </p><div class=\"home_layout_title\" id=\"jump_step_4\" data-v-3bd6fa4e>STEP4 応募・書類選考</div><p class=\"home_layout_text_list\" data-v-3bd6fa4e>興味のある求人企業があればあなたを推薦し、選考に進みます。</p><p class=\"home_layout_text_list\" data-v-3bd6fa4e>通常、1週間程度で、選考結果が判明します。結果はわかり次第、お知らせします。</p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 人気のある求人ほどすぐに採用が決まります。ご紹介後3日以内を目安に応募のご意向をお知らせください。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 応募書類のつくり方や作品集のつくり方に不安な点がある場合、お気軽にご相談ください。求人企業の特徴に合わせてアドバイスします。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> マスメディアンへ提出いただいた書類から複数の企業へ応募が可能です。書類作成・印刷・郵送の手間も省けます。 </p><div class=\"home_layout_link\" data-v-3bd6fa4e><a class=\"text_link\" href=\"https://www.massmedian.co.jp/service/flow/documents.html\" target=\"_blank\" data-v-3bd6fa4e> マスメディアン経由で応募企業へ提出する書類について ＞ </a></div><p class=\"home_layout_text\" data-v-3bd6fa4e>＜応募書類作成マニュアル＞</p>", 34)
const _hoisted_51 = { class: "home_manual_download" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "home_manual_download" }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "home_manual_download" }
const _hoisted_56 = ["href"]
const _hoisted_57 = { class: "home_manual_download" }
const _hoisted_58 = ["href"]
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"home_layout_title\" id=\"jump_step_5\" data-v-3bd6fa4e>STEP5 面接</div><p class=\"home_layout_text_list\" data-v-3bd6fa4e> キャリアコンサルタントがあなたに代わって、企業と面接日程を調整します。「仕事が忙しくて、転職活動ができない」という方も、仕事を辞めずに転職活動を行うことができます。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> マスメディアンでは、キャリアコンサルタントが企業面接に同席しています。各企業の面接現場を肌で知っているため、事前に実践的で細かなアドバイスが受けられます。（一部企業は除く） </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e>選考結果のフィードバックを受けられるため、次の選考での改善につなげられます。</p><div class=\"home_layout_title\" id=\"jump_step_6\" data-v-3bd6fa4e>STEP6 内定・条件交渉・入社</div><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 入社日や給与をはじめとした各種条件面のデリケートな交渉も、キャリアコンサルタントがあなたに代わって調整します。交渉相手の企業は、やがてあなたが働く場所です。入社後の印象まで考えて、双方にとってベストな契約となるように調整します。 </p><p class=\"home_layout_text_list\" data-v-3bd6fa4e>退職に関するアドバイスも受け付けています。</p><p class=\"home_layout_text_list\" data-v-3bd6fa4e> 入社後もご相談やお悩みがあれば、いつでも気軽にお問い合わせください。転職の目標は「入社」ではなく、入社後の活躍やキャリアアップ、望む生活・環境を手に入れることにあります。そのために、マスメディアンを最大限に活用してください。 </p>", 8)

import BaseButton from '@/components/BaseButton.vue';
import Indicator from '@/components/Indicator.vue';
import { UserMenu } from '@/types';
import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import RESUME_PATH from '@/constants/documentPath';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlankCareerView',
  props: {
  menu: {
    type: Object as PropType<UserMenu>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const links = {
  1: { name: 'c00', indicatorValue: 0 },
  2: { name: 'c01', indicatorValue: 1 },
  3: { name: 'c02', indicatorValue: 2 },
  4: { name: 'c03', indicatorValue: 3 },
  6: { name: 'c07', indicatorValue: 5 },
  7: { name: 'c08', indicatorValue: 6 },
  8: { name: 'c09', indicatorValue: 7 },
  9: { name: 'c10', indicatorValue: 8 },
  10: { name: 'c11', indicatorValue: 9 },
  11: { name: 'c12', indicatorValue: 10 },
  12: { name: 'c14', indicatorValue: 11 },
} as Record<number, { name: string; indicatorValue: number }>;

const router = useRouter();



const indicatorValue = () => {
  const status = props.menu.careersheetNonInputStatus || 0;
  const link = links[status];
  if (link) {
    return link.indicatorValue;
  }
  return 0;
};

const go = () => {
  const status = props.menu.careersheetNonInputStatus || 0;
  const link = links[status];
  router.push({ name: link.name });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Indicator, {
              current: indicatorValue(),
              max: 12
            }, null, 8, ["current"])
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseButton, {
              theme: "primary",
              type: "button",
              onClick: go
            }, {
              default: _withCtx(() => [
                _createTextVNode("キャリアシートへ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_16, [
          _createVNode(BaseButton, {
            theme: "primary",
            type: "button",
            onClick: go
          }, {
            default: _withCtx(() => [
              _createTextVNode("キャリアシートへ")
            ]),
            _: 1
          })
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['marketing'],
            download: ""
          }, "広報・宣伝・マーケティング", 8, _hoisted_52)
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['ae'],
            download: ""
          }, "営業・プロデューサー", 8, _hoisted_54)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['creator'],
            download: ""
          }, " グラフィックデザイナー・コピーライター・Webクリエイター ", 8, _hoisted_56)
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['editor'],
            download: ""
          }, "編集者", 8, _hoisted_58)
        ]),
        _hoisted_59
      ])
    ])
  ]))
}
}

})